module.exports = __webpack_public_path__ + "img/Nutrition.98390990.svg";